import { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export const AIDraftDialog = ({ open, onOpenChange, uid, entities, onDraft }) => {
  const [entityId, setEntityId] = useState("none");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/universes/${uid}/calendars/draft`, { entity_id: entityId === "none" ? null : entityId, text });
      onDraft(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="ai-calendar-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl">Draft a calendar from lore</DialogTitle></DialogHeader>
        <p className="text-sm text-[#A8A090]">The scribe reads an entry or your text and proposes months, weeks, moons and holidays. You review everything before it is saved.</p>
        <div className="space-y-4 py-3">
          <div className="space-y-1.5">
            <Label>From an entry</Label>
            <Select value={entityId} onValueChange={setEntityId}>
              <SelectTrigger data-testid="ai-calendar-entity-select"><SelectValue /></SelectTrigger>
              <SelectContent className="max-h-72">
                <SelectItem value="none">— None —</SelectItem>
                {entities.map((e) => <SelectItem key={e.id} value={e.id}>{e.name} · {e.category}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>…and/or describe it</Label>
            <Textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} data-testid="ai-calendar-text-input"
              placeholder="Days on Kepler-9b last 31 hours. Eight months of 40 days, a five-day week, twin moons…" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={run} disabled={busy || (entityId === "none" && text.trim().length < 10)} data-testid="ai-calendar-draft-button">
            <Sparkles className="mr-1.5 h-4 w-4" />{busy ? "Drafting…" : "Draft calendar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
